/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface AvailabilityWindowCreateRequest { 
    availabilityMode?: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    windowDate: string;
    fromTime: string;
    toTime: string;
    ignoreWarnings?: boolean;
}
export namespace AvailabilityWindowCreateRequest {
}

export const AvailabilityWindowCreateRequest_availabilityMode_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityWindowCreateRequest_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityWindowCreateRequest_windowDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindowCreateRequest_fromTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindowCreateRequest_toTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindowCreateRequest_ignoreWarnings_Validators: ValidatorFn[] =
    [ ];


